import dayjs from "dayjs";

const relativeTime = require("dayjs/plugin/relativeTime");

dayjs.extend(relativeTime, {
  thresholds: [
    { l: "s", r: 1 },
    { l: "m", r: 1 },
    { l: "mm", r: 59, d: "minute" },
    { l: "h", r: 1 },
    { l: "hh", r: 23, d: "hour" },
    { l: "d", r: 1 },
    { l: "dd", r: 29, d: "day" },
    { l: "M", r: 1 },
    { l: "MM", r: 11, d: "month" },
    { l: "y", r: 1 },
    { l: "yy", d: "year" }
  ],
  rounding: Math.floor,
});

const SERVER_DATE_SEPARATOR = "-";

export const CLIENT_DATE_FORMAT = "DD.MM.YYYY";


export const fromNow = (date) => {
  if (!date) {
    return "";
  }

  const dateObject = dayjs(date);

  const timeDifferenceFromNow = dayjs().diff(dateObject, "second");

  if (timeDifferenceFromNow < 44) {
    return "a few seconds ago";
  } else if (timeDifferenceFromNow < 90) {
    return "44 seconds ago";
  }

  return dateObject.fromNow();
};

export const formatDateToDateLabel = (date) => {
  return date ? dayjs(date).format(CLIENT_DATE_FORMAT) : '';
};

const parseServerDate = (date) => {
  if (!date) {
    return null;
  }

  const [year, month, day] = date.split(SERVER_DATE_SEPARATOR);
  return {
    year,
    month,
    date: day
  };
};

export const formatServerDateToJSDate = (date) => {
  let dateObject = dayjs();

  if (date) {
    const serverDateParsed = parseServerDate(date);

    if (serverDateParsed) {
      const { year, month, date, } = serverDateParsed;
      if (date) { dateObject = dateObject.date(date); }
      if (month) { dateObject = dateObject.month(parseInt(month) - 1); }
      if (year) { dateObject = dateObject.year(year); }
    }
  }

  return dateObject.toDate();
};

export const formatToServerDate = (date) => {
  return dayjs(date).format("YYYY-MM-DD");
}

export const isBeforeDateISO = (dateOld, dateNew) => {
  if (!dateOld) {
    return true;
  }
  if (!dateNew) {
    return false;
  }
  try {
    const dateOldISO = dayjs(dateOld);
    const dateNewISO = dayjs(dateNew);
    return dateOldISO.isSame(dateNewISO) || dateNewISO.isAfter(dateOldISO);
  } catch (e) {
    return true;
  }
};

export const isSameDateMonthYear = (date1, date2) => {
  return dayjs(date1).isSame(date2, "date")
    && dayjs(date1).isSame(date2, "month")
    && dayjs(date1).isSame(date2, "year");
};